import PageContainer from "../PageContainer/PageContainer";
import styles from "./styles.module.css";

export default function PageIntroduction({
  title,
  subTitle,
  message,
  contrastText,
}: {
  title?: string;
  subTitle?: string;
  message?: string;
  contrastText?: boolean;
}) {
  return (
    <div className={styles.container}>
      <PageContainer>
        <div className={contrastText ? styles["primary-contrast-text"] : ""}>
          {title && <h1>{title}</h1>}

          {subTitle && <h2>{subTitle}</h2>}

          {message && <p>{message}</p>}
        </div>
      </PageContainer>
    </div>
  );
}
